<div class="flex flex-col gap-6">
  <div class="flex w-full justify-between mt-6 border-b border-neutral-300 py-4 sticky top-0 bg-white z-50">
    <span class="text-[18px] font-bold">
      <i
        [class.pi]="true"
        [class.pi-file-edit]="true"
        style="font-size: 2rem"></i>
      SUBSANAR SISTEMA DE IA
    </span>
    <div class="flex gap-4">
      <app-buttons
        [label]="'Cancelar'"
        (click)="backPage()" />
      <app-buttons
        [label]="'Enviar subsanación'"
        [disabled]="form.invalid || !canSubmitCorrection()"
        [classes]="'bg-primary-base text-primary-light disabled:bg-primary-base disabled:opacity-75'"
        type="button"
        (click)="onSave()" />
    </div>
  </div>
  <div
    *ngIf="!loading() && errorMessage()"
    class="border-l-4 border-alert-base bg-alert-light p-4 text-alert-dark">
    {{ errorMessage() }}
  </div>

  <form
    *ngIf="!loading() && !errorMessage()"
    [formGroup]="form"
    class="flex flex-col gap-10">
    <section class="flex flex-col gap-6 py-4">
      <div class="flex flex-col gap-3">
        <span class="text-[24px] font-bold">
          {{ form.get('systemName')?.value || '-' }}
        </span>
        <p class="text-[16px] text-neutral-dark">
          Revisa los campos del sistema de IA que requieren corrección. Los campos solicitados para subsanar se marcarán
          en el formulario. Para poder enviar de nuevo el sistema a aprobación, deberás revisar y corregir todos los
          campos indicados.
        </p>
      </div>
    </section>

    <div class="border-2 border-alert-base bg-neutral-100 rounded-sm px-6 py-4 flex items-start gap-3">
      <img
        src="assets/svg/alert.svg"
        alt="alert"
        class="w-4 h-4 mt-1" />
      <div class="flex flex-col gap-4 w-full">
        <div class="flex flex-col">
          <span class="font-bold text-base">Sistema de IA pendiente de subsanación</span>
          <span class="text-sm mt-1">
            Los revisores del sistema han solicitado subsanar
            {{ initialObservedFieldsCount() === 1 ? 'el siguiente' : 'los siguientes' }}
            <strong>{{ initialObservedFieldsCount() }}</strong>
            {{ initialObservedFieldsCount() === 1 ? 'campo' : 'campos' }}:
          </span>
        </div>

        @if (correctionFieldsSummary().length) {
          <div class="flex flex-col gap-3">
            <div class="grid grid-cols-1 md:grid-cols-2 gap-x-10 gap-y-4">
              @for (group of correctionFieldsSummary(); track group.section) {
                <div class="flex flex-col gap-1">
                  <span class="text-sm font-semibold">- {{ group.sectionLabel }}</span>

                  <ul class="list-disc pl-5 text-sm text-neutral-dark">
                    @for (field of group.fields; track field.formField) {
                      <li>{{ field.label }}</li>
                    }
                  </ul>
                </div>
              }
            </div>
          </div>
        }
      </div>
    </div>

    <div class="flex flex-col">
      <app-review-comments-block [comments]="reviewComments"></app-review-comments-block>
    </div>

    <div class="flex flex-col gap-6">
      <div class="text-[18px] font-bold">Datos funcionales</div>
      <div class="grid grid-cols-2 gap-3">
        <div class="flex flex-col flex-1">
          <div class="flex flex-col relative">
            <label
              [ngClass]="{ 'relative -top-4': isObserved('systemType') }"
              class="text-[16px]">
              Tipo de sistemas*
            </label>
            <app-observed-field-alert
              *ngIf="isObserved('systemType')"
              class="absolute top-2 left-0"></app-observed-field-alert>
          </div>
          <desy-select
            formControlName="systemType"
            classes="min-w-full mt-2">
            <desy-label>Selecciona un tipo de sistema</desy-label>
            <desy-option
              [disabled]="true"
              [hidden]="true"
              [selected]="true"
              value="">
              Selecciona el tipo de sistema
            </desy-option>
            <desy-option
              *ngFor="let item of typeSystem"
              [id]="item.label"
              [value]="item.value">
              {{ item.label }}
            </desy-option>
          </desy-select>
          <desy-error-message
            *ngIf="getError(form, 'systemType', formSubmitted()) as error"
            class="-mt-2">
            {{ error }}
          </desy-error-message>
        </div>

        <div class="flex flex-col flex-1 mt-4 gap-2">
          <span>Otro tipo de sistema*</span>
          <desy-input
            [formControl]="otherSystemTypeControl"
            placeholder="Especifica el tipo de sistema"
            [classes]="'w-full mt-2'"></desy-input>
        </div>
        <desy-error-message *ngIf="getError(form, 'otherSystemType', formSubmitted()) as error">
          {{ error }}
        </desy-error-message>
      </div>

      <div class="flex flex-col gap-6">
        <div class="flex flex-col gap-3">
          <div class="flex flex-col relative">
            <label
              [ngClass]="{ 'relative -top-4': isObserved('functionOfSystem') }"
              class="text-[16px] font-bold">
              Funciones o tareas a las que da soporte el sistema*
            </label>
            <app-observed-field-alert
              *ngIf="isObserved('functionOfSystem')"
              class="absolute top-2 left-0"></app-observed-field-alert>
          </div>
          <desy-tree
            [name]="name"
            [id]="id"
            [type]="type"
            formControlName="functionOfSystem"
            [idPrefix]="idPrefix"
            [expandedFirstLevel]="true">
            <desy-tree-items-generator
              [items]="autogeneratedItems"
              [itemTemplate]="itemTemplate"></desy-tree-items-generator>

            <ng-template
              #itemTemplate
              let-item="item">
              <desy-tree-item
                [id]="idPrefix + '-' + item.id"
                [value]="item.value"
                [expanded]="item.expanded"
                [disabled]="item.disabled">
                <desy-label>{{ item.label }}</desy-label>

                <desy-tree-sub *ngIf="item.sub && item.sub.items.length">
                  <ng-container *ngFor="let subItem of item.sub.items">
                    <ng-container *ngTemplateOutlet="itemTemplate; context: { item: subItem }"></ng-container>
                  </ng-container>
                </desy-tree-sub>
              </desy-tree-item>
            </ng-template>
          </desy-tree>
          <desy-error-message
            *ngIf="getError(form, 'functionOfSystem', formSubmitted()) as error"
            class="-mt-10">
            {{ error }}
          </desy-error-message>
        </div>

        <div class="flex flex-col flex-1 gap-2">
          <div class="flex flex-1 gap-2 items-center">
            <div class="flex flex-col w-[50%] gap-2 relative">
              <label
                [ngClass]="{ 'relative -top-4': isObserved('otherFunctions') }"
                class="text-[16px]"
                for="otherFunctions">
                Otras funciones o tareas
              </label>
              <app-observed-field-alert
                *ngIf="isObserved('otherFunctions')"
                class="absolute top-2 left-0"></app-observed-field-alert>
              <desy-input
                id="otherFunctions"
                [classes]="'w-full'"
                [placeholder]="'Escribe aquí'"
                [ngModel]="otherFunction()"
                (ngModelChange)="otherFunction.set($event)"
                [ngModelOptions]="{ standalone: true }"></desy-input>
            </div>
            <div class="mt-2">
              <app-buttons
                type="button"
                (click)="addFunctions($event)"
                [label]="'Añadir'"
                [classes]="'bg-primary-base text-white'"></app-buttons>
            </div>
          </div>
          <div class="flex justify-between mb-4 -mt-8">
            <div class="flex gap-1 flex-wrap">
              @for (item of otherFunctions(); track $index) {
                <app-pill
                  [isDeletable]="true"
                  [classe]="'c-pill--primary'"
                  [value]="item"
                  (accions)="removeFunctions($event)" />
              }
            </div>
          </div>
        </div>

        <div class="flex flex-col gap-1 relative">
          <label
            [ngClass]="{ 'relative -top-4': isObserved('description') }"
            class="text-[18px]">
            Descripción del funcionamiento del sistema*
          </label>
          <span class="text-[16px] text-neutral-dark">
            Descripción básica y concisa de la información utilizada por el sistema (datos, entradas) y su lógica de
            funcionamiento
          </span>
          <app-observed-field-alert
            *ngIf="isObserved('description')"
            class="absolute top-2 left-0"></app-observed-field-alert>
          <desy-textarea
            formControlName="description"
            classes="w-full"
            class="w-full"
            [rows]="5"
            [maxlength]="500"></desy-textarea>
          <desy-error-message
            *ngIf="getError(form, 'description', formSubmitted()) as error"
            class="-mt-6">
            {{ error }}
          </desy-error-message>
        </div>

        <div class="flex flex-col gap-1 relative">
          <label
            [ngClass]="{ 'relative -top-4': isObserved('estimatedDeployDate') }"
            class="text-[16px]">
            Fecha estimada de despliegue del sistema*
          </label>
          <app-observed-field-alert
            *ngIf="isObserved('estimatedDeployDate')"
            class="absolute top-2 left-0"></app-observed-field-alert>
          <app-date-picker
            [inline]="false"
            [placeholder]="'Seleccione una fecha'"
            [minDate]="minSelectableDate"
            [keepInvalid]="true"
            formControlName="estimatedDeployDate" />
          <desy-error-message
            *ngIf="getError(form, 'estimatedDeployDate', formSubmitted()) as error"
            class="mt-1">
            {{ error }}
          </desy-error-message>
        </div>
      </div>
    </div>

    <div class="flex flex-col gap-6">
      <span class="text-xl font-bold">Datos identificativos</span>
      <div class="flex flex-col flex-1 gap-2 relative">
        <label
          [ngClass]="{ 'relative -top-4': isObserved('aiSystemProviderType') }"
          class="text-[16px]">
          Proveedor del sistema de IA*
        </label>
        <app-observed-field-alert
          *ngIf="isObserved('aiSystemProviderType')"
          class="absolute top-2 left-0"></app-observed-field-alert>
        <desy-select
          formControlName="aiSystemProviderType"
          classes="min-w-full">
          <desy-label>Seleccione proveedor de sistema</desy-label>
          <desy-option
            [disabled]="true"
            [hidden]="true"
            [selected]="true"
            value="">
            Selecciona el proveedor de sistema
          </desy-option>
          <desy-option
            *ngFor="let item of systemProviderOptions"
            [id]="item.label"
            [value]="item.value">
            {{ item.label }}
          </desy-option>
        </desy-select>
        <desy-error-message
          *ngIf="getError(form, 'aiSystemProviderType', formSubmitted()) as error"
          class="-mt-2">
          {{ error }}
        </desy-error-message>
      </div>

      <div class="flex flex-col flex-1 relative">
        <label
          [ngClass]="{ 'relative -top-4': isObserved('aiProviderName') }"
          class="text-[16px]">
          Nombre del proveedor*
        </label>
        <app-observed-field-alert
          *ngIf="isObserved('aiProviderName')"
          class="absolute top-2 left-0"></app-observed-field-alert>
        <desy-textarea
          formControlName="aiProviderName"
          classes="w-full"
          class="w-full"
          [rows]="5"
          [placeholder]="'Si el proveedor es externo, especifique cuál es'"
          [maxlength]="100"></desy-textarea>
        <desy-error-message
          *ngIf="getError(form, 'aiProviderName', formSubmitted()) as error"
          class="-mt-6">
          {{ error }}
        </desy-error-message>
      </div>
    </div>

    <div class="flex flex-col gap-6">
      <span
        [ngClass]="{ 'relative -top-4': isObserved('aiModelName') }"
        class="text-xl font-bold">
        Cuestiones técnicas
      </span>
      <div class="flex flex-col flex-1 -mt-4 relative">
        <label
          [ngClass]="{ 'relative -top-4': isObserved('aiModelName') }"
          class="text-[16px]">
          Modelo de IA*
        </label>
        <app-observed-field-alert
          *ngIf="isObserved('aiModelName')"
          class="absolute top-2 left-0"></app-observed-field-alert>
        <desy-textarea
          formControlName="aiModelName"
          classes="w-full"
          class="w-full"
          [rows]="5"
          [placeholder]="'Nombre del modelo o familia de modelos utilizados'"
          [maxlength]="200"></desy-textarea>
        <desy-error-message
          *ngIf="getError(form, 'aiModelName', formSubmitted()) as error"
          class="-mt-6">
          {{ error }}
        </desy-error-message>
      </div>
    </div>

    <div class="flex flex-col gap-1 relative">
      <span
        [ngClass]="{ 'relative -top-4': isObserved('estimatedFunctionalInputVolume') }"
        class="text-xl font-bold">
        Datos de entrada
      </span>
      <label
        [ngClass]="{ 'relative -top-4': isObserved('estimatedFunctionalInputVolume') }"
        class="text-[16px]">
        Volumen funcional estimado de entrada*
      </label>
      <label class="text-[16px] text-neutral-dark">
        Estimación/volumen real del número total de unidades e información (documentos, páginas, consultas, etc.) que el
        sistema de IA procesara durante un periodo de referencia (normalmente un año)
      </label>
      <app-observed-field-alert
        *ngIf="isObserved('estimatedFunctionalInputVolume')"
        class="absolute top-10 left-0"></app-observed-field-alert>
      <desy-input
        [type]="'number'"
        id="estimatedFunctionalInputVolume"
        [classes]="'w-1/2'"
        formControlName="estimatedFunctionalInputVolume"></desy-input>
      <desy-error-message
        *ngIf="getError(form, 'estimatedFunctionalInputVolume', formSubmitted()) as error"
        class="-mt-2">
        {{ error }}
      </desy-error-message>
    </div>

    <div class="flex flex-col gap-6">
      <span class="text-xl font-bold">Cumplimiento de reglamento IA</span>
      <div class="grid grid-cols-2 gap-4">
        <div class="flex flex-col flex-1 relative">
          <span [ngClass]="{ 'relative -top-4': isObserved('administrationRole') }">
            Papel de la administración respecto al sistema de IA*
          </span>
          <app-observed-field-alert
            *ngIf="isObserved('administrationRole')"
            class="absolute top-2 left-0"></app-observed-field-alert>
          <desy-select
            formControlName="administrationRole"
            classes="min-w-full mt-2">
            <desy-option
              [value]="5"
              [selected]="true"
              [hidden]="true"></desy-option>
            <desy-option
              *ngFor="let item of administrationRoleOptions"
              [id]="item.label"
              [value]="item.value">
              {{ item.label }}
            </desy-option>
          </desy-select>
          <desy-error-message
            *ngIf="getError(form, 'administrationRole', formSubmitted()) as error"
            class="-mt-2">
            {{ error }}
          </desy-error-message>
        </div>
        <div class="flex flex-col flex-1 relative">
          <span [ngClass]="{ 'relative -top-4': isObserved('dataType') }">Tipo de datos *</span>
          <app-observed-field-alert
            *ngIf="isObserved('dataType')"
            class="absolute top-2 left-0"></app-observed-field-alert>
          <desy-select
            formControlName="dataType"
            classes="min-w-full mt-2">
            <desy-option
              [disabled]="true"
              [hidden]="true"
              [selected]="true"
              value="">
              Selecciona el tipo de datos
            </desy-option>
            <desy-option
              *ngFor="let item of dataTypeOptions"
              [id]="item.label"
              [value]="item.value">
              {{ item.label }}
            </desy-option>
          </desy-select>
          <desy-error-message
            *ngIf="getError(form, 'dataType', formSubmitted()) as error"
            class="-mt-2">
            {{ error }}
          </desy-error-message>
        </div>
        <div
          class="flex flex-col flex-1 relative"
          *ngIf="isOtherDataTypeSelected">
          <span [ngClass]="{ 'relative -top-4': isObserved('otherDataType') }">Otro tipo de datos *</span>
          <app-observed-field-alert
            *ngIf="isObserved('otherDataType')"
            class="absolute top-2 left-0"></app-observed-field-alert>
          <desy-input
            [formControl]="otherDataTypeControl"
            placeholder="Especifica el tipo de datos"
            [classes]="'w-full mt-2'"></desy-input>
          <desy-error-message
            *ngIf="getError(form, 'otherDataType', formSubmitted()) as error"
            class="-mt-2">
            {{ error }}
          </desy-error-message>
        </div>
        <div class="flex flex-col flex-1 relative">
          <span [ngClass]="{ 'relative -top-4': isObserved('explainabilityLevel') }">
            Nivel de explicabilidad del modelo*
          </span>
          <app-observed-field-alert
            *ngIf="isObserved('explainabilityLevel')"
            class="absolute top-2 left-0"></app-observed-field-alert>
          <desy-select
            formControlName="explainabilityLevel"
            classes="min-w-full mt-2">
            <desy-option
              [disabled]="true"
              [hidden]="true"
              [selected]="true"
              value="">
              Selecciona el nivel de explicabilidad
            </desy-option>
            <desy-option
              *ngFor="let item of explainabilityLevelOptions"
              [id]="item.label"
              [value]="item.value">
              {{ item.label }}
            </desy-option>
          </desy-select>
          <desy-error-message
            *ngIf="getError(form, 'explainabilityLevel', formSubmitted()) as error"
            class="-mt-2">
            {{ error }}
          </desy-error-message>
        </div>
      </div>
    </div>

    <div class="flex flex-col gap-6">
      <span class="text-xl font-bold">Datos económicos</span>
      <div class="grid grid-cols-2 gap-4">
        <div class="flex flex-col flex-1 relative">
          <span [ngClass]="{ 'relative -top-4': isObserved('contractingImport') }">Importe contratación (€) *</span>
          <app-observed-field-alert
            *ngIf="isObserved('contractingImport')"
            class="absolute top-2 left-0"></app-observed-field-alert>
          <desy-input
            [type]="'number'"
            id="contractingImport"
            [classes]="'w-full'"
            formControlName="contractingImport"></desy-input>
          <desy-error-message
            *ngIf="getError(form, 'contractingImport', formSubmitted()) as error"
            class="-mt-6">
            {{ error }}
          </desy-error-message>
        </div>
        <div class="flex flex-col flex-1 relative">
          <span [ngClass]="{ 'relative -top-4': isObserved('contractValidity') }">
            Vigencia contratación (en meses)*
          </span>
          <app-observed-field-alert
            *ngIf="isObserved('contractValidity')"
            class="absolute top-2 left-0"></app-observed-field-alert>
          <desy-input
            [type]="'number'"
            id="contractValidity"
            [classes]="'w-full'"
            formControlName="contractValidity"></desy-input>
          <desy-error-message
            *ngIf="getError(form, 'contractValidity', formSubmitted()) as error"
            class="-mt-6">
            {{ error }}
          </desy-error-message>
        </div>
        <div class="flex flex-col flex-1 relative">
          <span [ngClass]="{ 'relative -top-4': isObserved('annualAmount') }">Importe anual del sistema (€)*</span>
          <app-observed-field-alert
            *ngIf="isObserved('annualAmount')"
            class="absolute top-2 left-0"></app-observed-field-alert>
          <desy-input
            [type]="'number'"
            id="annualAmount"
            [classes]="'w-full'"
            formControlName="annualAmount"></desy-input>
          <desy-error-message
            *ngIf="getError(form, 'annualAmount', formSubmitted()) as error"
            class="-mt-6">
            {{ error }}
          </desy-error-message>
        </div>
        <div class="flex flex-col flex-1 relative">
          <span [ngClass]="{ 'relative -top-4': isObserved('estimatedAnnualSavings') }">
            Ahorro anual estimado del sistema (€)*
          </span>
          <app-observed-field-alert
            *ngIf="isObserved('estimatedAnnualSavings')"
            class="absolute top-2 left-0"></app-observed-field-alert>
          <desy-input
            [type]="'number'"
            id="estimatedAnnualSavings"
            [classes]="'w-full'"
            formControlName="estimatedAnnualSavings"></desy-input>
          <desy-error-message
            *ngIf="getError(form, 'estimatedAnnualSavings', formSubmitted()) as error"
            class="-mt-6">
            {{ error }}
          </desy-error-message>
        </div>
        <div class="flex flex-col gap-1 relative">
          <label
            [ngClass]="{ 'relative -top-4': isObserved('contractValidityDate') }"
            class="text-[16px]">
            Finalización vigencia contratación*
          </label>
          <app-observed-field-alert
            *ngIf="isObserved('contractValidityDate')"
            class="absolute top-2 left-0"></app-observed-field-alert>
          <app-date-picker
            [inline]="false"
            class="w-full flex-1"
            [placeholder]="'Seleccione una fecha'"
            [minDate]="minSelectableDate"
            [keepInvalid]="true"
            formControlName="contractValidityDate" />
          <desy-error-message
            *ngIf="getError(form, 'contractValidityDate', formSubmitted()) as error"
            class="mt-2">
            {{ error }}
          </desy-error-message>
        </div>
      </div>
    </div>

    <div class="flex flex-col gap-6">
      <span class="text-xl font-bold">Gestión del riesgo</span>
      <div class="flex gap-3">
        <div class="flex flex-col flex-1 relative">
          <label
            [ngClass]="{ 'relative -top-4': isObserved('systemClassification') }"
            class="text-[16px]">
            Clasificación del sistema*
          </label>
          <app-observed-field-alert
            *ngIf="isObserved('systemClassification')"
            class="absolute top-2 left-0"></app-observed-field-alert>
          <desy-select
            formControlName="systemClassification"
            classes="w-[50%] mt-2">
            <desy-label>Seleccione clasificación del sistema</desy-label>
            <desy-option
              [disabled]="true"
              [hidden]="true"
              [selected]="true"
              value="">
              Selecciona la clasificación
            </desy-option>
            <desy-option
              *ngFor="let item of systemClassificationOptions"
              [id]="item.label"
              [value]="item.value">
              {{ item.label }}
            </desy-option>
          </desy-select>
          <desy-error-message
            *ngIf="getError(form, 'systemClassification', formSubmitted()) as error"
            class="-mt-2">
            {{ error }}
          </desy-error-message>
        </div>
      </div>
    </div>
  </form>
</div>
